module.exports = __webpack_public_path__ + "static/media/power-transmission.e51b6efc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/power-transmission.svg
// module id = 293
// module chunks = 0